import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2899e668"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ExpressZoneListItem__information" }
const _hoisted_2 = { class: "information__name" }
const _hoisted_3 = { class: "ExpressZoneListItem__actions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash text-red-500" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ExpressZoneListItem", { 'ExpressZoneListItem--disabled': _ctx.disabled }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "information__color",
        style: _normalizeStyle(`background-color: ${_ctx.item.color}`)
      }, null, 4),
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.item.name) + " (" + _toDisplayString(_ctx.item.type.name) + ")", 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "actions__button",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onView && _ctx.onView(...args)))
      }, _hoisted_5),
      (_ctx.isCanDelete)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "actions__button ml-2",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
          }, _hoisted_7))
        : _createCommentVNode("", true),
      (_ctx.isCanUpdate)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "actions__button ml-2",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onUpdate && _ctx.onUpdate(...args)))
          }, _hoisted_9))
        : _createCommentVNode("", true)
    ])
  ], 2))
}